import { IForm } from "../../Interface/IForm";

import {
	ToolGroup,
	ToolGroupMaintenence,
	ToolGroupPortalMaintenence,
} from "./FormGroup";


export const ToolForm: IForm = {
	id: "toolform",
	groups: [ToolGroup],
	isValid: false,
	isVisible: true,
	title:""
};

export const ToolForms : IForm[] = [ToolForm];

export const ToolFormMaintainence : IForm = {
	id: "toolform",
	groups: [ToolGroupMaintenence],
	isValid: false,
	isVisible: true,
	title:""
};

export const ToolForm_Maintainence : IForm[] = [ToolFormMaintainence];


export const PortalMaintainence : IForm = {
	id: "toolform",
	groups: [ToolGroupPortalMaintenence],
	isValid: false,
	isVisible: true,
	title:""
};

export const Portal_Maintainence : IForm[] = [PortalMaintainence];
